import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[horizontalListCustomTemplate]',
    standalone: false
})
export class HorizontalListCustomTemplateDirective {
  @Input('horizontalListCustomTemplate')
  name!: string;
  
  constructor(public templateRef: TemplateRef<any>) { }
}
